import { render, staticRenderFns } from "./DeclassamentoMateriale.vue?vue&type=template&id=2e50a380&scoped=true"
import script from "./DeclassamentoMateriale.vue?vue&type=script&lang=js"
export * from "./DeclassamentoMateriale.vue?vue&type=script&lang=js"
import style0 from "./DeclassamentoMateriale.vue?vue&type=style&index=0&id=2e50a380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e50a380",
  null
  
)

export default component.exports